import { appTheme } from "./app"

export const MTTheme = (appTheme.components["MuiSelect"] = {
  styleOverrides: {
    root: {
      fontSize: "0.9rem",
    },
  },
})
